import styled from 'styled-components';

export const MainWrapper = styled.div`
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: Montserrat, sans-serif;
`;
